import URL from './url'
import http from '@/utils/httpUtils'

export default {
  getDormTransSkyConfig(postData) {
    return http.get(URL.API_GET_CROSS_HOUR, postData)
  },
  // 判断是否为宿舍管理员
  getIsDormAdmin(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_ISDORM_ADMIN, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询机构宿舍日统计
  getDormData(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_DORM_DATA, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // // 查询机构宿舍日详情
  getDormDetail(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_DORM_DETAIL, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  // 新增宿管考勤组
  saveDromGroup(postData) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SAVE_DORM_GROUP, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询机构宿舍日详情
  updateDormGroup(postData) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_UPDATE_DORM_GROUP, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询单个宿管考勤组
  getDormGroup(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_DORM_GROUP, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询全部宿管考勤组
  getDormGroupList(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_DORM_GROUP_LIST, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 删除宿管考勤组
  deleteDormGroup(postData) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_DELETE_DORM_GROUP, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询机构校区今日的宿管考勤统计(按照考勤组和时段或者班级统计)
  getDormReport(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_DORM_REPORT, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询机构校区今日的宿管考勤统计明细
  getDormReportDetail(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_DORM_REPORT_DETAIL, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询某个学生的宿管考勤打卡记录
  getUserDormReport(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_USER_DORM_REPORT, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  //  查询某个学生的考勤日历
  getUserDormCalendar(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_USER_DORM_CALENDAR, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询宿管考勤组的多个时间配置
  getDormGroupPeriod(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_GROUP_PERIOD, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询周日历
  getDormWeekCalendar(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_DORM_WEEK_CALENDAR, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 导出宿管签到记录为Excel
  exportDormData(postData) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_EXPORT_DORM_DATA, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 宿舍模式获取考勤时段
  getListDormGroup(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_LIST_DORM_GROUP, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取班牌的 appType
  getClassPadAppType(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_PAD_APP_TYPE, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 设备重启接口
  deviceReBoot(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_DEVICE_RE_BOOT, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  // 获取校区下的宿舍树
  getDormTree(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_DORM_TREE, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 校区下有哪些模式的班牌
  getDeviceMode(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_DEVICE_MODE, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 宿舍模式绑定宿舍和考勤组
  dormModeBind(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_DEVICE_DORM_MODE_BIND, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  deviceDormBuilding(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_DEVICE_DORM_BUILDING, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  modifySignRecord(params) {
    return http.post(URL.API_MODIFY_DORM_ATTENDACE_RESULT, params)
  }
}
